import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

/**
 * Laufzeit-Konfiguration, von CDK als `/config.json` neben das Bundle
 * deployt (Cognito-IDs sind erst nach dem Deploy bekannt) -- oeffentliche
 * Werte, kein Secret (SR-7).
 */
export interface AuthConfig {
  readonly apiBaseUrl: string;
  /** Cognito-Issuer: https://cognito-idp.<region>.amazonaws.com/<userPoolId> */
  readonly authority: string;
  readonly clientId: string;
  /** Hosted-UI-Domain ohne Schema, fuer den Logout-Endpunkt. */
  readonly cognitoDomain: string;
}

export async function loadAuthConfig(): Promise<AuthConfig> {
  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error(`config.json nicht ladbar (HTTP ${response.status}).`);
  }
  return (await response.json()) as AuthConfig;
}

let config: AuthConfig | null = null;
let userManager: UserManager | null = null;

/** security-design-web-oberflaeche SR-2: Tokens nur im sessionStorage. */
export function initAuth(authConfig: AuthConfig): void {
  config = authConfig;
  userManager = new UserManager({
    authority: authConfig.authority,
    client_id: authConfig.clientId,
    redirect_uri: window.location.origin,
    response_type: 'code',
    scope: 'openid email profile',
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  });
}

export function getUserManager(): UserManager {
  if (!userManager) {
    throw new Error('authConfig: initAuth() wurde nicht aufgerufen.');
  }
  return userManager;
}

/** Cognito kennt kein OIDC-`end_session_endpoint`; der Logout laeuft ueber die Hosted-UI-Domain. */
export function cognitoLogoutUrl(): string {
  if (!config) {
    throw new Error('authConfig: initAuth() wurde nicht aufgerufen.');
  }
  const params = new URLSearchParams({ client_id: config.clientId, logout_uri: window.location.origin });
  return `https://${config.cognitoDomain}/logout?${params.toString()}`;
}
